export default __webpack_public_path__ + "static/timberline-healthcare-large-ef93c973515838dc5853b5c296954c52.jpg";